var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import localforage from 'localforage';
/**
 * Get item from storage safely
 */
export function getItem(key, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const value = yield localforage.getItem(key);
            if (value === null || value === undefined)
                return options === null || options === void 0 ? void 0 : options.defaultValue;
            return value;
        }
        catch (err) {
            console.error(`Error reading storage key "${key}":`, err);
            return options === null || options === void 0 ? void 0 : options.defaultValue;
        }
    });
}
/**
 * Set item in storage safely
 */
export function setItem(key, value) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield localforage.setItem(key, value);
        }
        catch (err) {
            console.error(`Error setting storage key "${key}":`, err);
        }
    });
}
/**
 * Remove item from storage safely
 */
export function removeItem(key) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield localforage.removeItem(key);
        }
        catch (err) {
            console.error(`Error removing storage key "${key}":`, err);
        }
    });
}
/**
 * Clear all storage safely
 */
export function clearAll() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield localforage.clear();
        }
        catch (err) {
            console.error('Error clearing storage:', err);
        }
    });
}
